import { useQuery } from "@tanstack/react-query";
import { getTaskList } from "../api/todo.api";
import { TodoListResult } from "../api/type";
import { useTodoFilter } from "../context/TodoFilterContext";

export function useTaskList() {
  const { filter } = useTodoFilter();

  return useQuery<TodoListResult>({
    queryKey: ["task-list", filter],
    queryFn: () => getTaskList(filter),
    staleTime: 30_000,
  });
}
